<script setup lang="ts">
import { useConfigurator } from '@/composables/configurator/useConfigurator'

const { knowledge } = useConfigurator()
</script>

<template>
  <Knowledge v-model="knowledge" data-testid="knowledge-tab-content" />
</template>
